import { Dispatch } from 'react';
import { IMatch, IStoreState } from '@zmedia/bm-soccer-ui/interface';
import { TIMER_GET_LIVE } from '@zmedia/bm-soccer-ui/constants';
import { ArrayUtils, Logger } from '@zmedia/bm-soccer-ui/utils';
import LiveService from '@zmedia/bm-soccer-ui/service/LiveService';

export const LIVE_MATCHES_UPDATE = 'LIVE_MATCHES_UPDATE';
export const LIVE_MATCH_UPDATE = 'LIVE_MATCH_UPDATE';
export const IS_UPDATE_LIVE_MATCH = 'LIVE_MATCH_IS_UPDATE'

export const getLiveMatches = () => async (dispatch: Dispatch<any>, getState: () => IStoreState) => {
    const state = getState();
    const isUpdate = state.match.shouldUpdate;

    if (isUpdate) {
        LiveService.getList()
            .then((resp) => {
                if (resp && resp.data) {
                    const { items = [] } = resp.data;

                    if (ArrayUtils.isEmpty(items)) {
                        dispatch(liveMatchesUpdate([]));
                    }
                    else {
                        dispatch(liveMatchesUpdate(items));
                        const timeout = setTimeout(() => {
                            dispatch(getLiveMatches())
                        }, TIMER_GET_LIVE);
                        (window as any).timeoutLive = timeout;
                    }

                }
            })
            .catch((err) => {
                if (err) {
                    dispatch(liveMatchesUpdate([]));
                    Logger.error(err.err, 'getLiveMatch fail|', err);
                }
            });
    }
};

export const liveMatchesUpdate = (items: IMatch[]) => ({
    type: LIVE_MATCHES_UPDATE,
    payload: items,
});

export const liveMatchUpdate = (item: IMatch) => ({
    type: LIVE_MATCH_UPDATE,
    payload: item,
});


export const shouldUpdateLiveMatch = (update: boolean) => ({
    type: IS_UPDATE_LIVE_MATCH,
    payload: update,
});


